module.exports = __webpack_public_path__ + "img/network-effect.a649ed92.png";